
import React from 'react';
import { TranslationContent } from '../types';

interface WhatIDoProps {
  t: TranslationContent['whatIDo'];
}

const WhatIDo: React.FC<WhatIDoProps> = ({ t }) => {
  return (
    <section id="what-i-do" className="py-20 md:py-32 bg-slate-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-16 flex items-center gap-4">
          <span className="w-12 h-[2px] bg-indigo-600 rounded-full" />
          {t.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.items.map((item, idx) => (
            <div 
              key={idx} 
              className="p-8 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 font-bold text-lg">
                {idx + 1}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 leading-tight">
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;
